import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { parseMoment } from '@/shared/converters/dateConverters';
import SlaV2Note from '../models/SlaV2Note';
import SlaV2MediaFile from '../models/SlaV2MediaFile';
import SlaNoteType from '../models/SlaNoteType';

const NOTE_SCHEMA = {
  id: 'id',
  subject: 'subject',
  subjectIdentifier: 'subjectIdentifier',
  type: (data: any) => parseSlaType(data.type),
  modifiedOn: (data: any) => parseMoment(data.modifiedOn),
  modifiedById: 'modifiedById',
  modifiedByName: 'modifiedByName',
  visibilityLevel: 'visibilityLevel',
  validFrom: (data: any) => parseMoment(data.validFrom),
  validTill: (data: any) => parseMoment(data.validTill),
  content: 'content',
  mediaFile: (data: any) => parseSlaV2MediFile(data.mediaFile),
};

const MEDIA_SCHEMA = {
  entityId: 'entityId',
  entityType: 'entityType',
  subEntityId: 'subEntityId',
  subEntityType: 'subEntityType',
  id: 'id',
  mediaFileType: 'mediaFileType',
  isLocked: 'isLocked',
  isWarranty: 'isWarranty',
  createdOn: 'createdOn',
  createdById: 'createdById',
  description: 'description',
  note: 'note',
  originalContent: 'originalContent',
  originalSize: 'originalSize',
  mediumContent: 'mediumContent',
  mediumSize: 'mediumSize',
  smallContent: 'smallContent',
  smallSize: 'smallSize',
  extraSmallContent: 'extraSmallContent',
  extraSmallSize: 'extraSmallSize',
};

const TYPE_SCHEMA = {
  id: 'id',
  description: 'description',
};

export function parseSlaV2Notes(data: any) {
  return parseEntities(data, parseSlaV2Note);
}

export function parseSlaV2Note(data: any) {
  return parseEntity(data, NOTE_SCHEMA, SlaV2Note);
}

function parseSlaV2MediFile(data: any) {
  return parseEntity(data, MEDIA_SCHEMA, SlaV2MediaFile);
}

function parseSlaType(data: any) {
  return parseEntity(data, TYPE_SCHEMA, SlaNoteType);
}

export function parseSlaV2Types(data: any) {
  return parseEntities(data, parseSlaType);
}